import { Box, CircularProgress, Container, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';


const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

class Feriados extends Component {
    constructor(props){
        super(props);
        this.state = {
            feriado:{
                fecha: '',
                turismo: '0',
                medioHorario: '0',
                codigo: '',
                hasta: '',
            },
            notificaciones: null,
            errores: null,
            anio: '',
            datosConsulta: [],
            consultaRealizada: false,
            modalEditar: false,
            modalBorrar: false,
            datoEditar: {},
        }

        this.manejoEnvioFechas = this.manejoEnvioFechas.bind(this);
        this.manejarCambioFecha = this.manejarCambioFecha.bind(this);
        this.manejarCambioConsulta = this.manejarCambioConsulta.bind(this);
        this.manejoEnvioConsulta = this.manejoEnvioConsulta.bind(this);
        this.manejoEditar = this.manejoEditar.bind(this);
        this.manejoBorrar = this.manejoBorrar.bind(this);
        this.manejarEnvioEditar = this.manejarEnvioEditar.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.manejarCambioEditar = this.manejarCambioEditar.bind(this);
        this.manejarAtras = this.manejarAtras.bind(this);
        this.manejarEnvioBaja = this.manejarEnvioBaja.bind(this);
    }

    async componentDidMount(){}

    render(){
        return (
            <>
                {sessionStorage.login && sessionStorage.tipoUsuario === '4'
                ?
                    <Container>
                        <h3>Conceptos Generales</h3>
                        {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                        {this.state.consultaRealizada
                        ?
                            null
                        :
                            <form className='formulario1'  onSubmit={this.manejoEnvioConsulta}>
                                <Box sx={{ flexGrow: 1}} >
                                        <Grid container spacing={2} rowSpacing={1}>
                                            <Grid item xs={2.5}>
                                                <Item>Año</Item>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='anio' value={this.state.anio} onChange={this.manejarCambioConsulta} type="text" /></Item>
                                            </Grid>
                                            <Grid item xs={1}>
                                                <button className="btn btn-outline-primary mx-2" type='submit'>Consultar</button>
                                            </Grid>
                                        </Grid>
                                </Box>
                            </form>
                        }
                        {this.state.consultaRealizada
                        ?
                            <Container>
                                <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                    <Table sx={{minWidth: 700}}>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell>Concepto</StyledTableCell>
                                                <StyledTableCell>Desde</StyledTableCell>
                                                <StyledTableCell>Hasta</StyledTableCell>
                                                <StyledTableCell></StyledTableCell>
                                                <StyledTableCell></StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.state.datosConsulta.map((dato) => (
                                                <StyledTableRow key={dato.idFeriados}>
                                                    <StyledTableCell>{dato.codigo}</StyledTableCell>
                                                    <StyledTableCell>{ dato.fecha.substring(8,10) + '/' + dato.fecha.substring(5,7) + '/' + dato.fecha.substring(0,4)}</StyledTableCell>
                                                    <StyledTableCell>{ dato.hasta.substring(8,10) + '/' + dato.hasta.substring(5,7) + '/' + dato.hasta.substring(0,4)}</StyledTableCell>
                                                    <StyledTableCell><button className="btn btn-outline-primary" type='button' onClick={() => this.manejoEditar(dato)}>Editar</button></StyledTableCell>
                                                    <StyledTableCell><button className="btn btn-outline-danger" type='button' onClick={() => this.manejoBorrar(dato)}>Borrar</button></StyledTableCell>
                                                </StyledTableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <br/>
                                <button className="btn btn-outline-primary" type='button' onClick={this.manejarAtras}>Volver</button>
                                <br/>
                            </Container>
                        :
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Concepto</StyledTableCell>
                                            {this.state.feriado.codigo === '' || this.state.feriado.codigo === '1' || this.state.feriado.codigo === '2' ? <StyledTableCell>Fecha</StyledTableCell> : null}
                                            {this.state.feriado.codigo === '3' ? <StyledTableCell>Desde</StyledTableCell> : null}
                                            {this.state.feriado.codigo === '3' ? <StyledTableCell>Hasta</StyledTableCell> : null}
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow>
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigo'  value={this.state.feriado.codigo} onChange={this.manejarCambioFecha}>
                                                    <option value=''>CONCEPTO</option>
                                                        <option value='1'>FERIADO</option>
                                                        <option value='2'>RESOLUCION MEDIO HORARIO</option>
                                                        <option value='3'>TURISMO</option>
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} id='fecha' value={this.state.feriado.fecha} onChange={this.manejarCambioFecha} type="date" /></StyledTableCell>
                                            {this.state.feriado.codigo === '3' ? <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} id='hasta' value={this.state.feriado.hasta} onChange={this.manejarCambioFecha} type="date" /></StyledTableCell> : null}
                                            <StyledTableCell><button className="btn btn-outline-primary" type='button' onClick={this.manejoEnvioFechas}>Agregar</button></StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        }
                        <Modal open={this.state.modalEditar}>
                            <form className='formulario1'>
                                <Box sx={styleModal} >
                                <h3 style={{textAlign:'center'}}>Editar Movimiento</h3>
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={6}>
                                            <Item>Concepto</Item>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Item>{this.state.datoEditar.codigo}</Item>
                                        </Grid>
                                        <Grid item xs={2}>

                                        </Grid>
                                        <Grid item xs={6}>
                                            <Item>Desde</Item>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Item><input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} id='fecha' value={this.state.datoEditar.fecha} onChange={this.manejarCambioEditar} type="date" /></Item>
                                        </Grid>
                                        <Grid item xs={2}>

                                        </Grid>
                                        <Grid item xs={6}>
                                            <Item>Hasta</Item>
                                        </Grid>
                                        <Grid item xs={4}>
                                            {this.state.datoEditar.codigo === 'FERIADO' || this.state.datoEditar.codigo === 'RESOLUCION MEDIO HORARIO'
                                            ?
                                                <Item>{ this.state.datoEditar.hasta.substring(8,10) + '/' + this.state.datoEditar.hasta.substring(5,7) + '/' + this.state.datoEditar.hasta.substring(0,4)}</Item>
                                            :
                                                <Item><input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} id='hasta' value={this.state.datoEditar.hasta} onChange={this.manejarCambioEditar} type="date" /></Item>
                                            }
                                        </Grid>
                                        <Grid item xs={2}>

                                        </Grid>
                                        <Grid item xs={2}>

                                        </Grid>
                                        <Grid item xs={4}>
                                            <button className="btn btn-outline-danger mx-2" type='button' onClick={this.cerrarModal}>Cancelar</button>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarEnvioEditar}>Confirmar</button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </form>
                        </Modal>

                        <Modal open={this.state.modalBorrar}>
                            <form className='formulario1'>
                                <Box sx={styleModal} >
                                <h3 style={{textAlign:'center'}}>¿Confirmar Baja?</h3>
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={2}>

                                        </Grid>
                                        <Grid item xs={4}>
                                            <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioBaja}>Confirmar</button>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </form>
                        </Modal>
                    </Container>
                :
                <Redirect to='/login'/>
            }
            </>
        )//Final return
    }//Final render

    async manejoEnvioFechas(e){
        e.preventDefault();
        if(this.state.feriado.fecha === ''){
            this.setState({
                errores: 'DEBE INGRESAR LA FECHA DEL FERIADO!',
            })
        }else{
            const cargaUtil = JSON.stringify([this.state.feriado, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado]);

            const control = await fetch(`${Constantes.RUTA_API}/agregar_feriado.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res,
            });

            if(res === 'ok'){
                this.setState({
                    notificaciones: 'La fecha fue ingresada correctamente',
                    errores: null,
                    feriado:{
                        fecha: '',
                        turismo: '0',
                        medioHorario: '0',
                        codigo: '',
                        hasta: '',
                    },
                })
            }
        }
    }

    manejarCambioFecha(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
                notificaciones: null,
                errores: null,
        });

        this.setState(state =>{
            const movimientosActualizado = state.feriado;
            movimientosActualizado[clave] = valor;
            return{
                feriado: movimientosActualizado,
            };
        })
    }

    manejarCambioConsulta(e){
        e.preventDefault();
        const valor = e.target.value;
        this.setState({
            anio: valor,
            errores: null,
            notificaciones: null,
        });
    }

    async manejoEnvioConsulta(e){
        e.preventDefault();
        if(this.state.anio === ''){
            this.setState({
                errores: 'DEBE INGRESAR EL AÑO',
            });
        }else{
            const cargaUtil = JSON.stringify([this.state.anio, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado]);

            const control = await fetch(`${Constantes.RUTA_API}/obtener_feriados.php`,{
                method: 'POST',
                body: cargaUtil,
            })

            const res = await control.json();

            this.setState({
                errores: res[0],
                datosConsulta: [],
            })

            if(res[0] === 'ok'){
                this.setState({
                    errores: null,
                    datosConsulta: res[1],
                    consultaRealizada: true,
                })
            }
        }
    }

    manejoEditar(dato){
        this.setState({
            modalEditar: true,
            errores: null,
            notificaciones: null,
            datoEditar: dato,
        })
    }

    manejoBorrar(dato){
        this.setState({
            modalBorrar: true,
            errores: null,
            notificaciones: null,
            datoEditar: dato,
        })
    }

    async manejarEnvioEditar(e){
        e.preventDefault();
        if(this.state.datoEditar.fecha === ''){
            this.setState({
                errores: 'Debe ingresar a fecha desde!',
            })
        }else{
            const cargaUtil = JSON.stringify([this.state.datoEditar, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado]);

            const control = await fetch(`${Constantes.RUTA_API}/editar_feriado.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res[0],
                modalEditar: false,
            });

            if(res[0] === 'ok'){
                this.setState({
                    errores: null,
                    notificaciones: 'Los datos fueron actualizados correctamente!',
                    modalEditar: false,
                    consultaRealizada: false,
                    datosConsulta: [],
                })
            }
        }
    }

    cerrarModal(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            modalEditar: false,
            modalBorrar: false,
        })
    }

    manejarCambioEditar(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            notificaciones: null,
            errores: null,
        });

        this.setState(state =>{
            const movimientosActualizado = state.datoEditar;
            movimientosActualizado[clave] = valor;
            return{
                datoEditar: movimientosActualizado,
            };
        })
    }

    manejarAtras(e){
        e.preventDefault();
        this.setState({
            feriado:{
                fecha: '',
                turismo: '0',
                medioHorario: '0',
                codigo: '',
                hasta: '',
            },
            notificaciones: null,
            errores: null,
            anio: '',
            datosConsulta: [],
            consultaRealizada: false,
            modalEditar: false,
            modalBorrar: false,
            datoEditar: {},
        })
    }

    async manejarEnvioBaja(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify([this.state.datoEditar, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado]);

        const control = await fetch(`${Constantes.RUTA_API}/borrar_feriado.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState({
            errores: res[0],
            modalEditar: false,
        });

        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: 'Los datos fueron borrados correctamente!',
                modalBorrar: false,
                consultaRealizada: false,
                datosConsulta: [],
            })
        }
    }
}

export default Feriados